






/* eslint-disable @typescript-eslint/no-explicit-any */
import Vue from "vue";

export interface ShareData {
  title: string;
  text: string;
  url: string;
}

export default Vue.extend({
  props: {
    tag: {
      type: String,
      default: "div"
    },
    url: {
      type: String,
      required: true
    },
    title: {
      type: String,
      default: undefined
    },
    text: {
      type: String,
      default: undefined
    }
  },
  computed: {
    shareData(): ShareData {
      return { title: this.title, text: this.text, url: this.url };
    },
    shareSupported(): boolean {
      return !!(navigator as any).share;
    },
    fbShareURL(): string {
      return `https://www.facebook.com/sharer/sharer.php?u=${encodeURI(
        this.url
      )}&t=${encodeURI(this.title)}`;
    },
    twitterShareURL(): string {
      return `https://twitter.com/intent/tweet?url=${encodeURI(
        this.url
      )}&text=${encodeURI(this.text)}`;
    }
  },
  mounted() {
    if (!this.shareSupported && window.location.protocol !== "https:") {
      // eslint-disable-next-line no-console
      console.warn(
        "Share sheet cannot be detected or used with http. Only supports https. Disabling."
      );
    }
  },
  methods: {
    async share(): Promise<void> {
      if ((navigator as any).share && this.shareSupported) {
        try {
          await (navigator as any).share(this.shareData);
          this.$emit("success");
        } catch (err) {
          this.$emit("abort", err);
        }
      }
    }
  }
});
